<template>
  <div class="title">General Settings</div>
</template>

<script>
  export default {
    name: 'GenralSettings',
  }
</script>
